import React, { FC, ReactNode } from 'react'
import { Button, Card as VendorCard } from 'react-bootstrap'
import styled from 'styled-components'
import Icon from 'components/Icon'

import { $white, $gray_900, $danger } from 'utils/colors'

const S = {
    Card: styled(VendorCard)`
        border: 0;
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2),
            inset 0px 0px 0px 1px rgba(24, 28, 33, 0.15);
    `,
    CardHeader: styled.div`
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        padding: 27px 37px 40px 35px;
        background-color: ${$white};
    `,

    CardHeaderTitle: styled.h2`
        color: ${$gray_900};
        font-weight: bold;
        margin: auto auto -7px 0;
        padding: 20px 0 0 0;
    `,

    Error: styled.p`
        color: ${$danger};
        font-size: 12px;
        margin: 0;
    `,
}

export interface SortableListContainerProps {
    children: ReactNode
    onButtonAddClick(): void
    title: string
    addButton: string
    disableAddWithMessage?: string
}

const SortableListContainer: FC<SortableListContainerProps> = ({
    children,
    onButtonAddClick,
    title,
    addButton,
    disableAddWithMessage,
}: SortableListContainerProps) => (
    <S.Card>
        <S.CardHeader>
            <S.CardHeaderTitle>{title}</S.CardHeaderTitle>
            <div>
                <Button
                    variant="primary"
                    className="mt-auto mb-0 mr-0 ml-auto d-flex"
                    onClick={onButtonAddClick}
                    disabled={!!disableAddWithMessage}
                >
                    <Icon icon="plusBox" color="white" />
                    &nbsp;&nbsp;
                    {addButton}
                </Button>
                { disableAddWithMessage && <S.Error>{disableAddWithMessage}</S.Error>}
            </div>
        </S.CardHeader>
        {children}
    </S.Card>
)

export default SortableListContainer
